import { gql } from "@apollo/client";
import {
  DocketFilterNoNestingFragment,
  DocketTemplateNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { DocketTemplate as DocketTemplateEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import DocketTemplate from "../../data/model/DocketTemplate";
import { listOptions, listVariables } from "../constants";

import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const docketTemplatesQuery = gql`
  ${DocketTemplateNoNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
  ${DocketFilterNoNestingFragment}
  query GetDocketTemplates(${listVariables}) {
    docketTemplates(${listOptions}) {
        items{
            ...DocketTemplateNoNesting
            filters {
           ...DocketFilterNoNesting
            }
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
   
    }
  }
`;

export const docketTemplateDefinition = new EntityResourceDefinition<
  DocketTemplateEntity,
  DocketTemplate
>({
  entity: "docket_templates",
  query: docketTemplatesQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.defaultTemplateType.id = fetchedEntity.defaultTemplateTypeId;
    newEntity.name = fetchedEntity.name || "";
    newEntity.enabled = fetchedEntity.enabled;
    newEntity.filters = fetchedEntity.filters ?? [];
    newEntity.terminalIds = fetchedEntity.terminalIds ?? [];
    newEntity.automaticallyPrint = fetchedEntity.automaticallyPrint;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "docketTemplates", docketTemplatesQuery, options);
  },
});
